import api from "@/lib/api";

/** Első https:// sor = link; maradék = opcionális beillesztés (haladó). */
export function parseImportSource(raw) {
  const text = (raw || "").trim();
  if (!text) return { url: "", pageText: "", pageHtml: "" };
  const m = text.match(/https?:\/\/[^\s<>"']+/i);
  const url = m ? m[0] : text.split("\n")[0].trim();
  const isHtml = /<html[\s>]/i.test(text)
    || (text.includes("<") && text.includes(">") && text.length > 400);
  const body = text.replace(url, "").trim();
  return {
    url,
    pageText: isHtml ? body : text,
    pageHtml: isHtml ? text : "",
  };
}

/** Csak link mező — nincs beillesztett tartalom. */
export function parseImportUrl(url) {
  const u = (url || "").trim();
  return { url: u, pageText: "", pageHtml: "" };
}

/**
 * Cmd+A másolat a hirdetés oldalról — text/html + plain (képek URL-jei a HTML-ben).
 * @returns {Promise<{ pageText: string, pageHtml: string }>}
 */
export async function readImportClipboard() {
  if (!navigator.clipboard?.read) {
    throw new Error(
      "A böngésző nem enged vágólap-olvasást — használd a „Haladó beillesztés” mezőt, vagy Chrome/Safari + HTTPS.",
    );
  }
  const items = await navigator.clipboard.read();
  let pageHtml = "";
  let pageText = "";
  for (const item of items) {
    if (item.types.includes("text/html")) {
      pageHtml = await (await item.getType("text/html")).text();
    }
    if (item.types.includes("text/plain")) {
      pageText = await (await item.getType("text/plain")).text();
    }
  }
  if (!pageHtml && !pageText) {
    throw new Error("Üres vágólap — nyisd meg a hirdetést, Cmd+A, Cmd+C, majd próbáld újra.");
  }
  return { pageHtml: pageHtml.trim(), pageText: pageText.trim() };
}

/** @returns {Promise<{ ok, filled, images, warnings, source_title, source_url, needs_client_capture? }>} */
export async function importListingFromUrl(
  url,
  { importImages = true, pageText = "", pageHtml = "" } = {},
) {
  const body = {
    url: (url || "").trim(),
    import_images: !!importImages,
  };
  const text = (pageText || "").trim();
  const html = (pageHtml || "").trim();
  if (text) body.page_text = text;
  if (html) body.page_html = html;

  const r = await api.post("/import-listing-url", body, { timeout: 120_000 });
  return r.data;
}
